/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Intel1Inputs */

const id_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk komputer Mac lama dengan prosesor Intel.`)
};

const ms_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk komputer Mac lama dengan pemproses Intel.`)
};

const da_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til ældre Mac-computere med Intel-processorer.`)
};

const de_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für ältere Mac-Computer mit Intel-Prozessoren.`)
};

const en_us2_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For older Mac computers with Intel processors.`)
};

const es_es2_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac más antiguos con procesadores Intel.`)
};

const es_mx2_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac más antiguos con procesadores Intel.`)
};

const fil_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sa mas lumang Mac computer na may Intel processors.`)
};

const fr_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les Mac plus anciens avec processeurs Intel.`)
};

const it_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per computer Mac meno recenti con processori Intel.`)
};

const hu_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régebbi Mac számítógépekhez Intel processzorokkal.`)
};

const nl_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor oudere Mac-computers met Intel-processors.`)
};

const no_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For eldre Mac-datamaskiner med Intel-prosessorer.`)
};

const pl_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla starszych komputerów Mac z procesorami Intel.`)
};

const pt_br2_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para computadores Mac mais antigos com processadores Intel.`)
};

const pt_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Mac mais antigos com processadores Intel.`)
};

const ro_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentru Mac-uri mai vechi cu procesoare Intel.`)
};

const fi_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanhemmille Mac-tietokoneille, joissa on Intel-suoritin.`)
};

const sv_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För äldre Mac-datorer med Intel-processorer.`)
};

const vi_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho máy Mac cũ hơn với bộ xử lý Intel.`)
};

const tr_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel işlemcili daha eski Mac bilgisayarlar için.`)
};

const cs_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro starší Mac počítače s procesory Intel.`)
};

const bg_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За по-стари Mac компютри с Intel процесори.`)
};

const ru_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для старых компьютеров Mac с процессорами Intel.`)
};

const uk_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для старіших комп'ютерів Mac з процесорами Intel.`)
};

const ar_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لأجهزة Mac الأقدم بمعالجات Intel.`)
};

const hi_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel प्रोसेसर वाले पुराने Mac के लिए।`)
};

const th_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับ Mac รุ่นเก่าที่มีโปรเซสเซอร์ Intel`)
};

const ja_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel プロセッサ搭載の古い Mac コンピュータ向け。`)
};

const zh_cn2_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于搭载 Intel 处理器的较旧 Mac。`)
};

const zh_hant1_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用於搭載 Intel 處理器的較舊 Mac。`)
};

const ko_misc_downloads_assetinfo_intel1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Intel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intel 프로세서가 탑재된 구형 Mac 컴퓨터용.`)
};

/**
* | output |
* | --- |
* | "For older Mac computers with Intel processors." |
*
* @param {Misc_Downloads_Assetinfo_Intel1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_intel1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Intel1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Intel1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_intel1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_intel1(inputs)
	return ko_misc_downloads_assetinfo_intel1(inputs)
});
export { misc_downloads_assetinfo_intel1 as "misc.downloads.assetInfo.intel" }